<template>
    <b-modal
        id="myplan-cancel-subscription"
        centered
        hide-header
        content-class="py-3"
        @hide="resetModal">
        <p class="text-center">Please tell us why you wish to cancel your subscription.</p>
        <b-form>
            <b-form-group :invalid-feedback="errorMessage('message')">
                <b-form-textarea rows="3" max-rows="6" v-model="form.message" :state="isValid('message')"></b-form-textarea>
            </b-form-group>
        </b-form>
        <template slot="modal-footer">
            <b-button @click="$root.$emit('bv::hide::modal', 'myplan-cancel-subscription')">Cancel</b-button>
            <b-button variant="primary" @click="submitCancellation">Proceed</b-button>
        </template>
    </b-modal>
</template>

<script>
function initForm() {
    return {
        message: null
    }
}
export default {
    name: "MyPlanCancelSubscription",
    data() {
        return {
            form: initForm(),
            errors: null
        }
    },
    methods: {
        resetModal() {
            this.form = initForm();
            this.errors = null;
        },
        errorMessage(field) {
            return this.errors && this.errors[field]
                ? this.errors[field]
                : null;
        },
        isValid(field) {
            return this.errors && this.errors[field]
                ? false
                : null;
        },
        submitCancellation() {
            const errors = {};
            if (!this.form.message) errors['message'] = "This field is required.";
            this.errors = errors;

            if (!this.errors || Object.keys(this.errors).length === 0) {
                this.$emit('subscriptionCancelled', this.form.message);
            }
        }
    }
}
</script>
